export const STYLE_BG_COLOR = '#F6E5E5';
export const SECONDARY_COLOR = '#191F28';
export const PRIMARY_COLOR = '#FF8689';
export const COLOR_BLACK = '#222222';
export const STYLE_BTN_COLOR = { from: '#ed6ea0', to: '#ec8c69', deg: 35 };
